import { injectable, inject } from "inversify";
import { HttpService } from "src/core/services/http.service";

export interface PaginatedResult {
	total: number;
	pageSize: number;
	pageIndex: number;
	items: any[];
}

@injectable()
export default class CacheStoreService{

	@inject(HttpService)
	httpService: HttpService;

	public async getAccommodationStore(query: {}, pageSize: number = 100, pageIndex: number = 0): Promise<PaginatedResult> {
		return await this.getGenericStore(query, pageSize, pageIndex, 'accommodation');
	}

	public async getTransferStore(query: {}, pageSize: number = 100, pageIndex: number = 0): Promise<PaginatedResult> {
		return await this.getGenericStore(query, pageSize, pageIndex, 'transfer');
	}

	public async getGeneralStore(query: {}, pageSize: number = 100, pageIndex: number = 0): Promise<PaginatedResult> {
		return await this.getGenericStore(query, pageSize, pageIndex, 'general');
	}

	public async getCarrentStore(query: {}, pageSize: number = 100, pageIndex: number = 0): Promise<PaginatedResult> {
		return await this.getGenericStore(query, pageSize, pageIndex, 'carrent');
	}

	public async getTourStore(query: {}, pageSize: number = 100, pageIndex: number = 0): Promise<PaginatedResult> {
		return await this.getGenericStore(query, pageSize, pageIndex, 'tour');
	}


	public async flushCache() {
		return (await this.httpService.get('/api/v1/cache/flush')).data;
	}


	public async getMetadata() {
		var data = (await this.httpService.get('/api/v1/cache/meta')).data;

		console.log(data);

		return data;

	}

	public async getGenericStore(query: {}, pageSize: number, pageIndex: number, url: string): Promise<PaginatedResult> {
		return (await this.httpService.post('/api/v1/cache/' + url.toLowerCase(), {
			search: query,
			pageSize,
			pageIndex
		})).data;
	}
}



// WEBPACK FOOTER //
// ./src/app/general/cache/cache-store.service.ts